import useHistoricBondCreateBase from "./useHistoricBondCreateBase";
import { VA_HISTORIC_CREATE_CONFIG } from "./historicBondCreateConfig";

function useVABondCreateHistoric() {
  const {
    globalState,
    errors,
    setErrors,
    updateGlobalState,
    handleSubmit,
    isLoading,
    supportModalOpen,
    setSupportModalOpen,
    handleSupportRequestSubmit,
    submissionError,
  } = useHistoricBondCreateBase(VA_HISTORIC_CREATE_CONFIG);

  return {
    globalState,
    errors,
    setErrors,
    updateGlobalState,
    handleSubmit,
    isLoading,
    supportModalOpen,
    setSupportModalOpen,
    handleSupportRequestSubmit,
    submissionError,
  };
}

export default useVABondCreateHistoric;
